const message = {
  msg_1: '联系方式',
  msg_2: '联系电话',
  msg_3: '联系邮箱',
  msg_4: '联系地址：深圳市南山区南海大道1031号万海大厦B座7F',
}

export default message